import { render } from "./ShowIncidenceAdmin.vue?vue&type=template&id=cc86d822&scoped=true"
import script from "./ShowIncidenceAdmin.vue?vue&type=script&lang=js"
export * from "./ShowIncidenceAdmin.vue?vue&type=script&lang=js"

import "./ShowIncidenceAdmin.vue?vue&type=style&index=0&id=cc86d822&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc86d822"]])

export default __exports__